import styled, { css } from 'styled-components';

import DepositIcon from 'assets/icons/actions/icon-deposit-16.svg';
import WithdrawIcon from 'assets/icons/actions/icon-withdraw-16.svg';

import { cardBoxShadow, flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const sidebarPlacement = css`
    width: 48rem;
    min-width: 35rem;
    max-width: 48rem;
    margin-right: 2%;
    z-index: 102;

    ${respondDown(Breakpoints.lg)`
         float: unset;
         position: relative;
         min-width: unset;
         width: calc(100% - 3.2rem);
         margin: 1.6rem;
         box-shadow: unset;
         max-width: unset;
    `}
`;

export const Container = styled.aside`
    ${sidebarPlacement};
    float: right;
    position: relative;
    margin-top: -26rem;
`;

export const StickyContainer = styled.aside`
    ${sidebarPlacement};
    float: right;
    clear: right;
    position: sticky;
    top: 2rem;
    margin-top: 2.4rem;

    ${respondDown(Breakpoints.lg)`
        position: relative;
        top: unset;
    `}
`;

export const Card = styled.div`
    ${cardBoxShadow};
    background: ${COLORS.surface};
    padding: 3.2rem;
    border-radius: 4rem;

    ${respondDown(Breakpoints.md)`
        padding: 3.2rem 1.6rem;
    `}
`;

export const SidebarRow = styled.div`
    ${flexRowSpaceBetween};
    align-items: center;
    font-size: 1.4rem;
    line-height: 2rem;

    span {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        color: ${COLORS.textTertiary};
    }

    span:first-child {
        color: ${COLORS.textGray};
    }
`;

export const WithdrawIconStyled = styled(WithdrawIcon)`
    margin-right: 0.8rem;

    path {
        stroke: currentColor;
    }
`;
export const DepositIconStyled = styled(DepositIcon)`
    margin-right: 0.8rem;

    path {
        stroke: currentColor;
    }
`;

export const UserShares = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 2.4rem;
    gap: 1rem;
`;

export const Buttons = styled.div`
    display: flex;
    gap: 1.6rem;

    button {
        padding: 0;

        > div {
            color: ${COLORS.textPrimary};
        }

        &:disabled > div {
            color: ${COLORS.textGray};
        }
    }
`;

export const DistributionCanvas = styled.div`
    width: 100%;
`;
